<template>
	<side-window :tabs="tabs" :active="active" class="employee" title="Skadessag" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Status" v-model="entity.status" :options="status"/>
					<task-select-view v-model="entity" label="Opgave" :optional="true" @select="taskSelect" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Hjalp I/andre til?" v-model="entity.details.general.assisted" :options="[
						{
							label: 'Ja',
							value: true
						}, {
							label: 'Nej',
							value: false
						}
					]"/>
					<string-view label="Nedpak og klargøring af" v-model="entity.details.general.prepared_by" />
					<select-view label="Betalt fuldt" v-model="entity.details.general.paid" :options="[
						{
							label: 'Ja',
							value: true
						}, {
							label: 'Nej',
							value: false
						}
					]"/>
					<text-view label="Forklaring på manglende betaling" v-model="entity.details.general.why_not" />
					<text-view label="Kommentar fra medarbejder" v-model="entity.remarks" />
				</div>

				<div v-show="active == 'contact'">
					<string-view label="Navn" v-model="entity.details.contact.name" />
				</div>
				<div v-show="active == 'contact'">
					<string-view label="Adresse" v-model="entity.details.contact.address" />
					<string-view label="Postnr." v-model="entity.details.contact.zip" />
					<string-view label="By" v-model="entity.details.contact.city" />
					<string-view label="Land" v-model="entity.details.contact.country" />
				</div>
				<div v-show="active == 'contact'">
					<string-view label="E-mail" v-model="entity.details.contact.email" />
					<string-view label="Telefon" v-model="entity.details.contact.phone" />
				</div>

				<div v-show="active == 'claims'">
					<text-view label="Beskrivelse" v-model="entity.details.claim.description" :height="250" />
					<string-view label="Skadesum" v-model="entity.sum" />
					<select-view label="Er der indhentet tilbud på reparation?" v-model="entity.details.solution.quotes" :options="[
						{
							label: 'Ja',
							value: true
						}, {
							label: 'Nej',
							value: false
						}
					]"/>
					<text-view label="Forslag til løsning" v-model="entity.details.solution.request" />
				</div>
				<div v-show="active == 'claims'">
					<string-view label="Flyttet fra" v-model="entity.details.claim.from" />
					<string-view label="Flyttet til" v-model="entity.details.claim.to" />
				</div>
				<div v-show="active == 'claims'">
					<string-view label="Hvor er skaden sket?" v-model="entity.details.claim.where" />
					<date-select-view label="Hvornår er skaden sket?" v-model="entity.details.claim.when" :controller="$store.state.popupController" />
					<string-view label="Hvem påførte skaden?" v-model="entity.details.claim.who" />
				</div>

				<div v-show="active == 'files'">
					<file-list-view v-model="entity.details.files" />
				</div>

				<div v-show="active == 'notes'">
					<text-view label="Noter" v-model="entity.details.notes" :height="600" />
				</div>

				<div v-show="active == 'solution'">
					<string-view label="Forsikring andel" v-model="entity.insurance_part" />
					<string-view label="Intern andel" v-model="entity.internal_part" />
					<text-view label="Bemærkninger" v-model="entity.details.solution.notes" />
				</div>

				<div v-show="active == 'employees'" v-for="(e, i) in entity._embedded.employees" :key="i">
					<string-view :label="e.name" v-model="e.part" :optional="false" />
					<text-view label="Kommentar" v-model="e.comment" :optional="true" />
				</div>
			</form-grid-layout>
		</div>
		<div v-if="!id" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
		<div v-if="form && id" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
	</side-window>
</template>

<script>
	import ContactSelectView from '../views/TaskSelectView';
	import FileListView from '../views/FileListView';

	import merge from '../functions/merge';

	export default {
		data: function () {
			return {
				entity: {
					id: 			null,
					task_id: 		null,
					created: 		null,
					insurance_part:	0,
					internal_part:	0,
					status:			'open',
					closed:			null,
					sum:			0,
					details: {
						general: {
							assisted: 'Nej',
							prepared_by: 'Holger Danske',
							paid: 'Ja',
							why_not: 'hmm'
						},
						contact: {
							name: 'Nicolaj Andersen',
							address: 'Baunegårdsvej 12',
							zip: '7000',
							city: 'Fredericia',
							country: 'Danmark',
							email: 'nicolaj.andersen@gmail.com',
							phone: '31 40 58 88',
						},
						claim: {
							description: 'Mit dyre TV bord er ridset i siden',
							dop: '2018-03-05',
							price: 5000,

							from: 'Ejstruphøj 84, 9460 Brovst',
							to: 'Baunegårdsvej 12, 7000 Fredericia',
							where: 'Brovst',
							when: '2020-04-05',
							who: 'Ved jeg ikke',

							repair_price: 1000
						},
						notes: '',
						solution: {
							notes: ''
						},
						files: []
					},
					employees: [
						{
							id: 1,
							name: 'Nicolaj Andersen',
							part: 0,
							fault: false
						}
					],
					_embedded: {
						task: null
					}
				},
				active: 'details',
				week: {
					mon: 'Mandag',
					tue: 'Tirsdag',
					wed: 'Onsdag',
					thu: 'Torsdag',
					fri: 'Fredag',
					sat: 'Lørdag',
					sun: 'Søndag'
				},
				customer: {
					domain: ''
				},
				status: []
			};
		},
		components: {
			'ContactSelectView': ContactSelectView,
			'FileListView': FileListView
		},
		watch: {
			entity: {
				deep: true,
				handler: function () {
					
				}
			}
		},
		computed: {
			tabs: function () {
				//this.id = 

				//if (this.id) {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						},
						{
							name: 'contact',
							label: 'Kontakt'
						},
						{
							name: 'claims',
							label: 'Skader'
						},
						{
							name: 'files',
							label: 'Filer'
						},
						{
							name: 'notes',
							label: 'Noter'
						},
						{
							name: 'solution',
							label: 'Løsning'
						},
						{
							name: 'employees',
							label: 'Medarbejdere'
						},
						/*{
							name: 'contacts',
							label: 'Contacts'
						}*/
					];
				/*} else {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						},
						{
							name: 'roles',
							label: 'Roller'
						},
						{
							name: 'privileges',
							label: 'Privilegier'
						},
						{
							name: 'departments',
							label: 'Afdelinger'
						},
						{
							name: 'working_hours',
							label: 'Arbejdstid'
						},
					];
				}*/
			}
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			},
			submit: {
				type: Function,
				default: function (entity) { return true; }
			},
			ent: {
				type: Object
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			taskSelect(obj) {
				

				// Update employees
				//var r = merge({}, this.entity);
				const emps = obj._embedded.bookings.employees;

				this.entity.employees = [];

				for (var i = 0; i < emps.length; ++i) {
					if (this.entity.employees.find(function (item) { return item.employee_id == emps[i].id; })) continue;

					this.entity.employees.push({
						employee_id: emps[i].id,
						name: emps[i].name,
						part: 0,
						fault: false
					});
				}
				


				/*this.entity.name = obj.name;
				this.entity.email = obj.email;
				this.entity.phone = obj.phone;*/
			},
			async update() {
				if (await this.submit(this.entity)) {
					this.$store.windowStack.pop();
				}
			},
			input(name, value) {
				this.entity[name] = value;
			}
		},
		created() {
			
		},
		async mounted() {
			this.status = (await this.axios.get('/claims/status/')).data;

			if (this.ent) {
				this.entity = merge({}, this.ent);

				//this.taskSelect((await this.axios.get(`/planning/tasks/${this.entity.task_id}/`)).data);
			}
		}
	}
</script>

<style lang="scss">
	
</style>
